// extracted by mini-css-extract-plugin
module.exports = {"list":"TerminalList_list__9zkc5"};